import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import {
  CSRF_TOKEN,
  requestCallback,
} from '../lib/helpers';

import {
  useModal,
} from '../hooks';

import Modal from './Modal';

const ModalDelete = ({
  klassName = 'Badge Badge--gray Badge--icon-trash',
  hideText = false, // Hide button text.
  reload = false,
  type,
  id,
}) => {
  const [
    modal,
    modalSet,
    $submitButton,
  ] = useModal({
    keyboardBindings: true,
  })

  const onToggleModal = () => {
    modalSet(!modal)
  }

  const onDelete = () => {
    requestCallback(axios.delete(`/${gon.currentProvider}/api/${type}s/${id}`, {
      data: {
        authenticity_token: CSRF_TOKEN
      }
    }), `/${gon.currentProvider}/${type}s`, reload)
  }

  return (
    <React.Fragment>
      <a
        className={klassName}
        onClick={onToggleModal}
      >
        {!hideText && 'Delete'}
      </a>

      <Modal
        isActive={modal}
        onToggleModal={onToggleModal}
      >
        <h3 className='Modal__h3'>Delete {type.replaceAll('_', ' ')} {id}</h3>

        <div className='Modal__p__wrapper'>
          <p className='Modal__p'>Are you sure you want to delete this {type.replaceAll('_', ' ')}? This action cannot be undone.</p>
        </div>

        <div className='Modal__footer Modal__footer--without-border'>
          <a
            className='Button Button--gray-light'
            onClick={onToggleModal}
          >
            Cancel
          </a>

          <button
            className='Button Button--blue'
            onClick={onDelete}
            ref={$submitButton}
          >
            Submit
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
}

ModalDelete.propTypes = {
  type: PropTypes.oneOf([
    'user', 'post', 'letter', 'group',
    'admin', 'device', 'message_action',
    'spam_url', 'background_music', 'game', 'genre',
    'promotion', 'group_categorie', 'recaptcha_verification',
    'registered_uuid', 'hashtag', 'access_token', 'email_reputation',
    'gift', 'wallet_beta_participant'
  ]),
};

export default ModalDelete;
